import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
export function Video({ autoplay, loop, controls, muted, poster, width, height, sources, children }) {
    //ref for autoplay
    const ref = useRef(null);
    //set scroll handler
    useEffect(() => {
        //decide whether to play at current scroll
        const checkAutoPlay = () => {
            if (!autoplay || !(ref === null || ref === void 0 ? void 0 : ref.current))
                return;
            //don't play it twice
            if (ref.current.played.length)
                return;
            //get vertical offset where half of video is showing
            const clientRect = ref.current.getBoundingClientRect();
            const startPlayingAt = window.innerHeight - clientRect.height / 2;
            //play if offset is greater than current scroll
            if (clientRect.top < startPlayingAt) {
                ref.current.play().catch((error) => console.warn(error));
            }
        };
        //fire on render in case
        checkAutoPlay();
        //add event listener
        window.addEventListener('scroll', checkAutoPlay, { passive: true });
        //clean up event listener when unmounting
        return () => {
            window.removeEventListener('scroll', checkAutoPlay);
        };
    }, [ref, autoplay]);
    //return video tag
    return (React.createElement(ResponsiveVideo, Object.assign({ "data-testid": "ui-video", ref: ref }, { loop, controls, muted, poster, width, height }), sources === null || sources === void 0 ? void 0 :
        sources.map((source) => (React.createElement("source", { key: source, src: source, type: getVideoType(source) }))),
        children));
}
const ResponsiveVideo = styled.video `
  display: block;
  height: auto;
  width: 100%;
`;
//get type property of video by url, eg video/mp4
function getVideoType(url) {
    const fileName = url.split('/').pop();
    const fileExtension = fileName === null || fileName === void 0 ? void 0 : fileName.split('.').pop();
    if (fileExtension) {
        if (['mp4'].includes(fileExtension))
            return 'video/mp4';
        if (['webm'].includes(fileExtension))
            return 'video/webm';
        if (['ogg', 'ogv'].includes(fileExtension))
            return 'video/ogg';
    }
    return undefined;
}
//# sourceMappingURL=Video.js.map